var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footerBox"},_vm._l((_vm.clickTabs),function(item){return _c('div',{key:item.id,staticClass:"btn"},[(item.status != _vm.obj.status)?_c('span',{class:{ btnHover: item.status == 0 },on:{"click":function($event){return _vm.submit(item)}}},[_vm._v(_vm._s(item.name))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }